const ASSET_BASE =
    "https://customer-assets-4nw71qhi.emergentagent.net/job_5556b6ab-b9ff-423c-8c3e-68f468f93186/artifacts";

export const LOGO_URL = `${ASSET_BASE}/f1c8d8aa0897d0be_Sevano_Blue_House_Mark__1_-removebg-preview.png`;

export const IMAGES = {
    heroInterior:
        "https://images.unsplash.com/photo-1556910638-6cdac31d44dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    livingSpace:
        "https://images.unsplash.com/photo-1666585958641-4f70887372a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    dishesCare:
        "https://images.unsplash.com/uploads/1413170239208ebba60a2/07d615e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMG1vZGVybiUyMGtpdGNoZW4lMjBkaXNod2FzaGluZyUyMGNhcmUlMjBoYW5kcyUyMGhvbWV8ZW58MHx8fHwxNzkzMzczMTM0fDA&ixlib=rb-4.1.0&q=85",
    sinkClean:
        "https://images.unsplash.com/photo-1736433622548-4adbbc1c2cf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMGtpdGNoZW4lMjBkaXNod2FzaGluZyUyMGNhcmUlMjBoYW5kcyUyMGhvbWV8ZW58MHx8fHwxNzkzMzczMTM0fDA&ixlib=rb-4.1.0&q=85",
    armchairCorner:
        "https://images.pexels.com/photos/5591855/pexels-photo-5591855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const LOCALITIES = [
    "Banamalipur",
    "Dhaleswar",
    "Ramnagar",
    "Shibnagar",
    "Krishnanagar",
    "Indranagar",
    "Kunjaban",
    "College Tilla",
    "Arundhutinagar",
    "Other Agartala locality",
];

export const PROBLEMS = [
    {
        title: "Your regular maid is unavailable",
        desc: "A last-minute cancellation on the busiest day of the week, with nobody to call.",
        icon: "CalendarX",
    },
    {
        title: "Unexpected guests are arriving",
        desc: "Family drops in tomorrow and the house needs a proper reset, fast.",
        icon: "DoorOpen",
    },
    {
        title: "You need a little extra help",
        desc: "Recovery, a new baby, a busy work stretch — sometimes you just need a hand.",
        icon: "HandHeart",
    },
    {
        title: "No reliable help at short notice",
        desc: "Word-of-mouth leads go cold, and there is no number you can actually trust.",
        icon: "PhoneOff",
    },
];

export const PILLARS = [
    {
        title: "Verified local helpers",
        desc: "Every helper is identity-checked and onboarded before their first booking.",
        icon: "BadgeCheck",
        status: "Planned",
    },
    {
        title: "Transparent pricing",
        desc: "Clear, upfront pricing before you confirm. No haggling, no surprises.",
        icon: "Receipt",
        status: "Planned",
    },
    {
        title: "Flexible duration",
        desc: "Book help for exactly as long as you need — no rigid monthly contracts.",
        icon: "Clock",
        status: "Planned",
    },
    {
        title: "Fair & dignified work",
        desc: "Fair wages and respectful treatment for every helper on the platform.",
        icon: "HeartHandshake",
        status: "Our promise",
    },
];

export const STEPS = [
    {
        step: "01",
        title: "Open Sevano",
        desc: "No account needed to look around. See what Sevano covers in your locality.",
    },
    {
        step: "02",
        title: "Pick your task",
        desc: "Sweeping, mopping, utensils or everyday chores — choose what you need done.",
    },
    {
        step: "03",
        title: "Set duration & request",
        desc: "Choose how long you need help and send the request. Nothing is confirmed yet.",
    },
    {
        step: "04",
        title: "Get matched",
        desc: "A helper is confirmed only once they accept. You see honest status at every step.",
    },
];

export const SERVICES = [
    {
        title: "Sweeping",
        desc: "Everyday floor care that keeps living spaces fresh and dust-free.",
        image: IMAGES.armchairCorner,
    },
    {
        title: "Mopping",
        desc: "Clean, sparkling floors across bedrooms, hallways and living rooms.",
        image: IMAGES.heroInterior,
    },
    {
        title: "Utensil washing",
        desc: "A clean sink and sanitized counter, ready for your next meal.",
        image: IMAGES.dishesCare,
    },
    {
        title: "Everyday chores",
        desc: "Dusting, surface care and tidy-ups — the little things, done well.",
        image: IMAGES.livingSpace,
    },
];

export const TEASERS = [
    {
        title: "Deep cleaning",
        desc: "Kitchens, washrooms and festival-prep resets.",
        icon: "Sparkles",
    },
    {
        title: "Repairs",
        desc: "Fans, switches and small fixes, on demand.",
        icon: "Wrench",
    },
    {
        title: "Laundry care",
        desc: "Washing, drying and crisp ironing.",
        icon: "Shirt",
    },
    {
        title: "And more",
        desc: "Shaped by what Agartala asks for next.",
        icon: "Home",
    },
];

export const MARQUEE_ITEMS = [
    "HOUSEHOLD HELP, MADE SIMPLER",
    "COMING SOON — AGARTALA",
    "DIGNITY-FIRST SERVICE",
    "HONEST STATUS, ALWAYS",
    "VERIFIED HELPERS",
    "YOUR TIME MATTERS",
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
